import moment from 'moment'
import { isEmpty } from 'lodash'
export const formatAuctionDateRange = (startDate, endDate) => {
  startDate = moment(startDate, 'YYYY-MM-DD')
  endDate = moment(endDate, 'YYYY-MM-DD')
  if (startDate.isValid() && endDate.isValid()) {
    // year difference
    if (startDate.year() - endDate.year() < 0) {
      return (
        startDate.format('MMM D, YYYY') + ' - ' + endDate.format('MMM D, YYYY')
      )
    } else if (startDate.month() - endDate.month() < 0) {
      // month difference
      return startDate.format('MMM D') + ' - ' + endDate.format('MMM D')
    } else {
      // same month
      return startDate.format('MMM D') + ' - ' + endDate.format('D')
    }
  }
  // default should be determined on start date
  return startDate.isValid() ? startDate.format('MMM D') : 'TBD'
}

export const formatAuctionDateTime = (date, time) => {
  date = moment(date, 'YYYY-MM-DD')
  date = date.isValid() ? date.format('MMM DD') : 'Date TBD'
  time = moment(time, 'hh:mm a')
  time = time.isValid() ? time.format('h:mma') : 'Time - Coming Soon'
  time = time === '12:00am' ? 'Time - Coming Soon' : time
  return date + ', ' + time
}

export const formatAuctionDate = date => {
  date = moment(date, 'YYYY-MM-DD')
  date = date.isValid() ? date.format('MMM DD') : 'Date TBD'
  return date
}

export const formatAuctionTime = time => {
  time = moment(time, 'hh:mm A')
  time = time.isValid() ? time.format('h:mm A') : 'Time - Coming Soon'
  time = time === '12:00 AM' ? 'Time - Coming Soon' : time
  return time
}

const addUrlParams = (url, key, val) => {
  const hasValidUrlProtocol = (url = '') =>
    typeof url === 'string' &&
    ['http://', 'https://'].some(protocol => url.startsWith(protocol))
  let listingURL = url
  if (hasValidUrlProtocol(url)) {
    listingURL = new URL(url)
    listingURL.searchParams.append(key, val)
    return listingURL.href
  } else {
    return listingURL
  }
}

export const formatListingImgUrl = (listingImageUrl, urlParams = {}) => {
  if (isEmpty(listingImageUrl) || isEmpty(urlParams)) return listingImageUrl
  let imgUrl = listingImageUrl
  Object.keys(urlParams).forEach(function (key) {
    imgUrl = addUrlParams(listingImageUrl, key, urlParams[key])
  })
  return imgUrl
}
